module.exports = __webpack_public_path__ + "img/planeacion-microsite-header.87f8ab8a.jpg";